// TimePicker.tsx
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import React, { useEffect, useState } from "react";

const hours = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, "0")
);
const minutes = ["00", "15", "30", "45"];
const ampmOptions = ["AM", "PM"];

interface Props {
  time?: string;
  setTime: (e: any) => void;
}

const TimePicker: React.FC<Props> = ({ time, setTime }) => {
  const [hour, setHour] = useState("12");
  const [minute, setMinute] = useState("00");
  const [ampm, setAmPm] = useState("AM");

  // Parse initial time when component mounts or time prop changes
  useEffect(() => {
    if (time) {
      const timeMatch = time.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (timeMatch) {
        const [, hourPart, minutePart, ampmPart] = timeMatch;
        setHour(hourPart.padStart(2, "0"));
        setMinute(minutePart);
        setAmPm(ampmPart.toUpperCase());
      }
    }
  }, [time]);

  const getFormattedTime = () => {
    return `${hour}:${minute} ${ampm}`;
  };

  useEffect(() => {
    setTime(getFormattedTime());
  }, [hour, minute, ampm, setTime]);

  return (
    <div className="flex flex-col gap-4 max-w-xs">
      <div className="flex gap-2 items-center">
        <div className="flex flex-col">
          <label className="text-sm text-muted-foreground">Hours</label>
          <Select onValueChange={setHour} value={hour}>
            <SelectTrigger className="w-[80px]">
              <SelectValue placeholder="HH" />
            </SelectTrigger>
            <SelectContent>
              {hours.map((h) => (
                <SelectItem key={h} value={h}>
                  {h}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-muted-foreground">Minutes</label>
          <Select onValueChange={setMinute} value={minute}>
            <SelectTrigger className="w-[80px]">
              <SelectValue placeholder="MM" />
            </SelectTrigger>
            <SelectContent>
              {minutes.map((m) => (
                <SelectItem key={m} value={m}>
                  {m}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-muted-foreground">AM/PM</label>
          <Select onValueChange={setAmPm} value={ampm}>
            <SelectTrigger className="w-[80px]">
              <SelectValue placeholder="AM/PM" />
            </SelectTrigger>
            <SelectContent>
              {ampmOptions.map((ap) => (
                <SelectItem key={ap} value={ap}>
                  {ap}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default TimePicker;
